import urlcat from 'urlcat';

import { createClient } from '../client';

import { API_BASE_URL } from '../config';
import { CANDIDATE_FORM } from '../config/endpoints';

const baseURL = urlcat(API_BASE_URL, CANDIDATE_FORM);
const client = createClient(baseURL);

export default class Candidate {
  static async getCandidateForm() {
    return client.get(``);
  }

  static async saveCandidateForm(data) {
    return client.post(``, data);
  }
}
